import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=79348b32&scoped=true&"
import script from "./ProcessECPERMIT.vue?vue&type=script&lang=js&"
export * from "./ProcessECPERMIT.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=79348b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79348b32",
  null
  
)

export default component.exports